module.exports = __webpack_public_path__ + "img/email.2869681b.svg";